export const SCHEDULE_EF_3_COLUMNS = {
  gridColumns: [
    {
      dataType: 'string',
      displayName: 'Legal Entity',
      propertyName: 'legalEntityId',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Name',
      propertyName: 'name',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Address 1',
      propertyName: 'address1',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Address 2',
      propertyName: 'address2',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Address 3',
      propertyName: 'address3',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'City',
      propertyName: 'city',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'State',
      propertyName: 'state',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Zip',
      propertyName: 'zip',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Country',
      propertyName: 'country',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Related Creditor on Line',
      propertyName: 'line',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Not Listed Explanation',
      propertyName: 'notListedExplaination',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Last 4 Digits',
      propertyName: 'last4Digits',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Category',
      propertyName: 'category',
    },

    {
      allowedValues: ['No', 'All', 'Address', 'Name'],
      dataType: 'enum',
      displayName: 'Redact',
      propertyName: 'redact',
      queryType: 'RedactType'
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Footnote',
      propertyName: 'footnote',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Entity Comments',
      propertyName: 'entityComments',
    },
  ],
};
